import {NgModule}                      from '@angular/core';
import {CommonModule}                  from '@angular/common';
import {TaskManagementReportComponent} from './components/task-management-report/task-management-report.component';
import {ApReportsOverviewComponent}    from './components/ap-reports-overview.component';
import {ApDynComponentModule}          from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApReportsRoutes}               from './ap-reports.routes';
import {PDFExportModule}               from '@progress/kendo-angular-pdf-export';
import {ApIconModule}                  from '../icons/ap-icon.module';
import {ApTranslationModule}           from '../translation/ap-translation.module';
import {ApMapModule}                   from '../map/ap-map.module';
import {ApUtilsModule}                 from '../ap-utils';
import {SoilSampleReportComponent}     from './components/soil-sample-report/soil-sample-report.component';
import {AgriportStoreModule}           from '../stores/stores.module';
import {ApStatisticsModule}            from '../statistics/ap-statistics.module';
import {ChartModule}                   from '@progress/kendo-angular-charts';

@NgModule({
  declarations: [ApReportsOverviewComponent, TaskManagementReportComponent, SoilSampleReportComponent],
  exports: [ApReportsOverviewComponent, TaskManagementReportComponent, SoilSampleReportComponent],
  imports: [
    CommonModule,
    ApReportsRoutes,
    ApDynComponentModule,
    PDFExportModule,
    ApIconModule,
    ApTranslationModule,
    ApMapModule,
    ApUtilsModule,
    AgriportStoreModule,
    ApStatisticsModule,
    ChartModule
  ],
  providers: []
})
export class ApReportsModule {
}
